import { z } from 'zod';
import { SystemSchema } from '../../entities/system/system.schema';
import { CapacityBindingSchema } from '../../shared/capacity';
import { SystemCapabilitySchema } from '../../shared/authorization';
import { IncludeDeletedRequestSchema } from '../../shared/include-deleted.schema';
/**
 * List Systems Request Schema
 * GET /api/v2/systems
 */ export const ListSystemsRequestSchema = IncludeDeletedRequestSchema.extend({
    filterBy: z.enum([
        'all',
        'owner'
    ]).optional()
});
/**
 * System With Capacity Schema
 * Extended system with computed capacity binding and per-instance capabilities
 */ export const SystemWithCapacitySchema = SystemSchema.extend({
    capacityBinding: CapacityBindingSchema.nullable(),
    // Absent for readers without SystemStatistics (it counts org-wide usage).
    totalUsers: z.number().optional(),
    capabilities: SystemCapabilitySchema
});
/**
 * List Systems Response Schema
 * GET /api/v2/systems
 */ export const ListSystemsResponseSchema = z.object({
    data: z.array(SystemWithCapacitySchema)
});

//# sourceMappingURL=list-systems.schema.js.map